import { isEmpty, toString } from 'lodash-es'

import { CellRendererParams } from '../EntityTable/types'
import { formatDateTime } from '@/utils/formatDateTime'

export const ShortDateCell = ({ dataItem, column }: CellRendererParams) => {
  const formatted = formatDateTime(dataItem.get(column.accessor), 'PP')
  return isEmpty(toString(formatted)) ? '-' : formatted
}
